"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoomInIcon = void 0;
const react_1 = __importDefault(require("react"));
const ZoomInIcon = (_a) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement("svg", Object.assign({ width: "38", height: "38", viewBox: "0 0 38 38", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("circle", { cx: "19", cy: "19", r: "19", fill: "none" }),
        react_1.default.createElement("path", { d: "M18.1667 24.8333C21.8486 24.8333 24.8333 21.8486 24.8333 18.1667C24.8333 14.4848 21.8486 11.5 18.1667 11.5C14.4848 11.5 11.5 14.4848 11.5 18.1667C11.5 21.8486 14.4848 24.8333 18.1667 24.8333Z", stroke: props === null || props === void 0 ? void 0 : props.stroke, strokeWidth: "1.66667", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M26.5 26.5L22.875 22.875", stroke: props === null || props === void 0 ? void 0 : props.stroke, strokeWidth: "1.66667", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M18.1667 15.6667V20.6667", stroke: props === null || props === void 0 ? void 0 : props.stroke, strokeWidth: "1.66667", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M15.6667 18.1667H20.6667", stroke: props === null || props === void 0 ? void 0 : props.stroke, strokeWidth: "1.66667", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.ZoomInIcon = ZoomInIcon;
